import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import { OutlinedInput } from '@material-ui/core';
import InputLabel from '@material-ui/core/InputLabel';

export default function StandardInputField({
  label,
  handleChange,
  value,
  required = false
}) {
  return (
    <FormControl variant={'outlined'} required={required}>
      <InputLabel>{label}</InputLabel>
      <OutlinedInput
        onChange={(e) => handleChange(e.target.value)}
        value={value}
        label={label}
      />
    </FormControl>
  );
}
